
import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import { FaEdit, FaTrash } from 'react-icons/fa';
import LeadModal from './LeadModal';
import ReactPaginate from 'react-paginate';
import { Link } from 'react-router-dom';
import { useAuth } from '../../../context/AuthContext';
import withPermission from '../../../utils/withPermission';
import { Modal, Card } from 'react-bootstrap';
import Swal from 'sweetalert2';
import Offcanvas from 'react-bootstrap/Offcanvas';
import { FaFilter } from "react-icons/fa";
import { saveAs } from "file-saver";
import LeadDetails from './LeadDetails';


const WithCreatePermission = withPermission(({ children }) => children, ['lead-create']);
const WithEditPermission = withPermission(({ children }) => children, ['lead-edit']);
const WithDeletePermission = withPermission(({ children }) => children, ['lead-delete']);

const LeadList = ({ }) => {
    const didFetchRef = useRef(false);
    const [searchQuery, setSearchQuery] = useState('');
    const debounceTimeoutRef = useRef(null);
    const [leads, setLead] = useState([]);
    const [currentPage, setCurrentPage] = useState(0);
    const [pageCount, setPageCount] = useState(0);
    const [showModal, setShowModal] = useState(false);
    const [selectedLeadId, setSelectedLeadId] = useState(null);
    const [selectedLeadData, setSelectedLeadData] = useState(null);
    const [errors, setErrors] = useState({});
    const [organisations, setOrganisation] = useState([]);
    const [contacts, setContacts] = useState([]);
    const [showLeadOffcanvas, setShowLeadOffcanvas] = useState(false);
    const [orgFilter, setorgFilter] = useState('');
    const [typeFilter, setTypeFilter] = useState('');
    const [filterDropdown, setFilterDropdown] = useState(null);
    const [salesUsers, setSalesUsers] = useState([]);
    const [salesUserFilter, setSalesUserFilter] = useState('');
    const { roles, dataScopes } = useAuth();
    const didInitialFetch = useRef(false);

    useEffect(() => {
        if (debounceTimeoutRef.current) {
            clearTimeout(debounceTimeoutRef.current);
        }

        debounceTimeoutRef.current = setTimeout(() => {
            fetchLead(1, searchQuery);
        }, searchQuery ? 1500 : 0);

        return () => {
            if (debounceTimeoutRef.current) {
                clearTimeout(debounceTimeoutRef.current);
            }
        };
    }, [searchQuery, orgFilter, typeFilter, salesUserFilter]); // Add salesUserFilter to the dependency array
    const handleSearchChange = (e) => {
        setSearchQuery(e.target.value);

    };
    const fetchLead = async (page = 1) => {
        try {
            const backendUrl = process.env.REACT_APP_BACKEND_URL;
            const userInfo = JSON.parse(localStorage.getItem('user-info'));
            const origin = localStorage.getItem('user-origin');

            const token = userInfo?.token;
            let params = { page };

            if (searchQuery) params.search = searchQuery;
            if (orgFilter) params.organisation_id = orgFilter; // Only add if not empty
            if (typeFilter) params.lead_source = typeFilter;
            if (salesUserFilter) params.created_by = salesUserFilter;
            const response = await axios.get(`${backendUrl}/api/leads`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Tenant-Origin': origin,
                },
                params,
            });

            if (response.data && response.data.data) {
                const { data, current_page, last_page } = response.data.data;
                setLead(data || []);
                setCurrentPage((current_page || 1) - 1);
                setPageCount(last_page || 0);
            }
        } catch (error) {
            console.error(`Error fetching :`, error);
        }
    };
    const fetchContacts = async () => {
        try {
            const backendUrl = process.env.REACT_APP_BACKEND_URL;

            const userInfo = JSON.parse(localStorage.getItem('user-info'));
            const origin = localStorage.getItem('user-origin');
            const token = userInfo?.token;
            const response = await axios.get(`${backendUrl}/api/contact`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Tenant-Origin': origin,
                },
                skipLoader: true,

            });

            const filteredContacts = response.data.Data.filter(
                contact => contact.type !== "instance" && contact.type !== "tenant"
            );

            setContacts(filteredContacts);
            setPageCount(response.data.last_page);

        } catch (error) {
            console.error('Error fetching contacts:', error);
        }
    };

    const fetchOrganisation = async () => {
        try {
            const backendUrl = process.env.REACT_APP_BACKEND_URL;
            const userInfo = JSON.parse(localStorage.getItem('user-info'));
            const origin = localStorage.getItem('user-origin');
            const token = userInfo?.token;

            const response = await axios.get(`${backendUrl}/api/organisation`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Tenant-Origin': origin,

                },
                skipLoader: true,


            });

            const data = response.data.data;

            setOrganisation(data);

        } catch (error) {
            console.error(`Error fetching :`, error);
        }
    };
    const fetchSalesUsers = async () => {
        try {
            const backendUrl = process.env.REACT_APP_BACKEND_URL;
            const userInfo = JSON.parse(localStorage.getItem('user-info'));
            const origin = localStorage.getItem('user-origin');
            const token = userInfo?.token;

            const response = await axios.get(`${backendUrl}/api/users`, {
                params: { role: 'Inside Sales' },
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Tenant-Origin': origin,
                },
            });
            setSalesUsers(response.data.users || []);
        } catch (error) {
            console.error("Error fetching sales users:", error);
        }
    };

    useEffect(() => {
        if (dataScopes?.includes('all') || roles?.some(r => r.toLowerCase() === 'superadmin')) {
            fetchSalesUsers();
        }
        fetchOrganisation();
        fetchContacts();
    }, []);
    const addLead = async (newLead) => {
        try {


            const backendUrl = process.env.REACT_APP_BACKEND_URL;
            const userInfo = JSON.parse(localStorage.getItem('user-info'));
            const origin = localStorage.getItem('user-origin');
            const token = userInfo?.token;

            // Corrected API endpoint with dynamic contact_type for adding
            const response = await axios.post(`${backendUrl}/api/leads`, newLead, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Tenant-Origin': origin,
                },
            });
            const createdLead = response.data.data;

            if (createdLead) {
                setLead((prevLead) => [...prevLead, createdLead]);
            } else {
                console.error('Creation failed, no data returned.');
            }

            handleCloseModal();
        } catch (error) {
            if (error.response?.data?.errors) {
                return error.response.data.errors; // Return validation errors
            } else {
                console.error(`Error adding organisation`, error);
            }
        }
    };


    const editLead = async (contactId, updatedData) => {
        try {

            const backendUrl = process.env.REACT_APP_BACKEND_URL;
            const userInfo = JSON.parse(localStorage.getItem('user-info'));
            const origin = localStorage.getItem('user-origin');
            const token = userInfo?.token;

            // Corrected API endpoint with dynamic contact_type for editing
            const response = await axios.put(`${backendUrl}/api/leads/${contactId}`, updatedData, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Tenant-Origin': origin,
                },
            });
            const updatedLead = response.data.Data;

            if (updatedLead) {
                setLead((prevLead) =>
                    prevLead.map((contact) => (contact.id === updatedLead.id ? updatedLead : contact))
                );
            } else {
                console.error('Update failed, no data returned.');
            }

            handleCloseModal();
        } catch (error) {
            if (error.response?.data?.errors) {
                return error.response.data.errors; // Return validation errors
            } else
                console.error(`Error updating`, error);
        }
    };

    const deleteLead = async (id) => {
        Swal.fire({
            title: "Are you sure?",
            text: "You won't be able to revert this!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#d33",
            cancelButtonColor: "#3085d6",
            confirmButtonText: "Yes, delete it!"
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    const backendUrl = process.env.REACT_APP_BACKEND_URL;
                    const userInfo = JSON.parse(localStorage.getItem('user-info'));
                    const origin = localStorage.getItem('user-origin');
                    const token = userInfo?.token;

                    // Corrected API endpoint with dynamic contact_type for deleting
                    await axios.delete(`${backendUrl}/api/leads/${id}`, {
                        headers: {
                            Authorization: `Bearer ${token}`,
                            'Tenant-Origin': origin,
                        },
                    });

                    setLead(leads.filter((contact) => contact.id !== id));
                    Swal.fire(
                        "Deleted!",
                        "The lead has been deleted.",
                        "success"
                    );
                } catch (error) {
                    console.error('Error deleting lead:', error);
                    Swal.fire(
                        "Error!",
                        "Failed to delete lead. Please try again.",
                        "error"
                    );
                }
            }
        });
    };

    const handleShowModal = (contactId = null) => {
        if (contactId) {
            const contactToEdit = leads.find((contact) => contact.id === contactId);
            if (contactToEdit) {
                setSelectedLeadData(contactToEdit);
            }
        } else {
            setSelectedLeadData(null);
        }
        setSelectedLeadId(contactId);
        setShowModal(true);
    };

    const handleCloseModal = () => {
        setShowModal(false);
        setSelectedLeadId(null);
        setSelectedLeadData(null);
        setErrors({});
    };

    const handlePageClick = (data) => {
        const selectedPage = data.selected + 1;
        fetchLead(selectedPage);
    };

    const [showConvertModal, setShowConvertModal] = useState(false);
    const [selectedLead, setSelectedLead] = useState(null);
    const [dealData, setDealData] = useState({
        deal_name: "",
        closed_date: "",
        stage: "",
        amount: "",
    });
    const handleConvertModal = (lead) => {
        setSelectedLead(lead);
        setDealData({
            deal_name: lead?.name || "",
            closed_date: "",
            stage: "",
            amount: "",
        });
        setShowConvertModal(true);
    };

    const handleConvertLeadToDeal = async () => {
        try {
            const backendUrl = process.env.REACT_APP_BACKEND_URL;
            const userInfo = JSON.parse(localStorage.getItem('user-info'));
            const origin = localStorage.getItem('user-origin');
            const token = userInfo?.token;

            const response = await axios.post(`${backendUrl}/api/deals/convert`, {
                name: dealData.deal_name,
                value: dealData.amount,
                closed_date: dealData.closed_date,
                stage: dealData.stage,
                probability: null,
                lead_id: selectedLead.id,
                organisation_id: selectedLead.organisation_id,
                lead_source: selectedLead.lead_source,
                partner_id: selectedLead.partner_id,
                type_id: selectedLead.contact_id,

            }, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Tenant-Origin': origin,
                },
            });

            if (response.data) {
                // Update the leads state to exclude the converted lead
                const updatedLeads = leads.filter((lead) => lead.id !== selectedLead.id);

                setLead(updatedLeads);
                setShowConvertModal(false);
                Swal.fire({
                    toast: true,
                    position: 'top-end',
                    icon: 'success',
                    title: 'Lead successfully converted!',
                    timer: 3000,
                    timerProgressBar: false,
                    showConfirmButton: false,
                    didOpen: () => {
                        const container = Swal.getContainer();
                        container.style.top = '50px';
                    },
                });
            }
        } catch (error) {
            console.error("Error converting lead to deal:", error);
        }
    };
    const [viewType, setViewType] = useState('list');

    const handleFilterChange = (filterType, value) => {
        if (filterType === 'org') setorgFilter(value);
        if (filterType === 'type') setTypeFilter(value);

        setFilterDropdown(null); // Close dropdown after selection
    };
    const Toast = Swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
            toast.onmouseenter = Swal.stopTimer;
            toast.onmouseleave = Swal.resumeTimer;
        },
    });

    const handleExportLeads = async () => {
        try {
            const userInfo = JSON.parse(localStorage.getItem("user-info"));
            const origin = localStorage.getItem("user-origin");
            const token = userInfo?.token;

            const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/leads/export`, {
                responseType: "blob",
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Tenant-Origin": origin,
                },
            });

            const blob = new Blob([response.data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
            saveAs(blob, `leads_${new Date().toISOString().split('T')[0]}.xlsx`);

            Toast.fire({
                icon: "success",
                title: "Leads exported successfully!",
            });
        } catch (error) {
            console.error("Export error:", error);
            Toast.fire({
                icon: "error",
                title: "Export failed! Please try again.",
            });
        }
    };

    const handleImportLeads = async (e) => {
        const file = e.target.files[0];
        if (!file) return;

        const formData = new FormData();
        formData.append("file", file);

        try {
            const userInfo = JSON.parse(localStorage.getItem("user-info"));
            const origin = localStorage.getItem("user-origin");
            const token = userInfo?.token;

            await axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/leads/import`, formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                    Authorization: `Bearer ${token}`,
                    "Tenant-Origin": origin,
                },
            });

            Toast.fire({
                icon: "success",
                title: "Leads imported successfully!",
            });
            setTimeout(() => window.location.reload(), 1000);

            e.target.value = "";
        } catch (error) {
            console.error("Import error:", error);
            Toast.fire({
                icon: "error",
                title: error.response?.data?.error || "Import failed! Please check your file.",
            });
            e.target.value = "";

        }
    };


    const handleShowLeadDetails = (leadId) => {
        setSelectedLeadId(leadId);
        setShowLeadOffcanvas(true);
    };

    const handleCloseLeadDetails = () => {
        setShowLeadOffcanvas(false);
        setSelectedLeadId(null);
    };
    return (
        <div className="main-content">
            <div className="page-content">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-12">
                            <div className="page-title-box d-sm-flex align-items-center justify-content-between">
                                <h4 className="mb-sm-0 font-size-18">
                                    Leads
                                </h4>
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-12">
                            {viewType === 'list' ? (
                                <div className="card">
                                    <div className="card-body">
                                        {/* <div className="d-flex justify-content-end mb-3"> */}
                                        <div className="d-flex justify-content-between mb-3">
                                            <div className="d-flex">
                                                <div className="search-box me-2 mb-1 d-inline-block">
                                                    <div className="position-relative">
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            placeholder="Search..."
                                                            value={searchQuery}
                                                            onChange={handleSearchChange}
                                                        />
                                                        <i className="bx bx-search-alt search-icon" />
                                                    </div>
                                                </div>

                                                {/* {(dataScopes?.includes('all') || roles?.some(r => r.toLowerCase() === 'superadmin')) && (
                                                    <div className="search-box me-2 mb-1 d-inline-block">
                                                        <select
                                                            className="form-select"
                                                            value={salesUserFilter}
                                                            onChange={(e) => setSalesUserFilter(e.target.value)}
                                                        >
                                                            <option value="">All Sales Users</option>
                                                            {salesUsers.map(user => (
                                                                <option key={user.id} value={user.id}>{user.name}</option>
                                                            ))}
                                                        </select>
                                                    </div>
                                                )} */}



                                            </div>
                                            {/* <div className="d-flex align-items-center">
                                                <div>
                                                    <ul className="nav nav-pills justify-content-end">
                                                        <li className="nav-item">
                                                            <a className="nav-link disabled" href="#" tabIndex={-1} aria-disabled="true"></a>
                                                        </li>
                                                        <li className="nav-item" data-bs-placement="top" title="List">
                                                            <a
                                                                className={`nav-link ${viewType === 'list' ? 'bg-primary bg-soft' : ''}`}
                                                                href="#"
                                                                onClick={() => setViewType('list')}
                                                            >
                                                                <i className="mdi mdi-format-list-bulleted" />
                                                            </a>
                                                        </li>
                                                        <li className="nav-item" data-bs-placement="top" title="Grid">
                                                            <a
                                                                className={`nav-link ${viewType === 'grid' ? 'bg-primary bg-soft' : ''}`}
                                                                href="#"
                                                                onClick={() => setViewType('grid')}
                                                            >
                                                                <i className="mdi mdi-view-grid-outline" />
                                                            </a>
                                                        </li>
                                                    </ul>
                                                </div>

                                                <WithCreatePermission>
                                                    <button
                                                        type="button"
                                                        className="btn rounded-circle border d-flex align-items-center justify-content-center round-create-button"

                                                        onClick={() => handleShowModal()}
                                                        data-bs-toggle="tooltip"
                                                        data-bs-placement="top"
                                                        title="Add Lead"
                                                    >
                                                        <i className="mdi mdi-plus" ></i>
                                                    </button>
                                                </WithCreatePermission>
                                            </div> */}
                                            <div className="d-flex align-items-center gap-2">
                                                {/* Export Button */}
                                                <button
                                                    type="button"
                                                    className="btn btn-light border"
                                                    onClick={handleExportLeads}
                                                    data-bs-toggle="tooltip"
                                                    data-bs-placement="top"
                                                    title="Export Leads to Excel"
                                                >
                                                    <i className="mdi mdi-file-excel text-success"></i>
                                                </button>

                                                {/* Import Button */}
                                                <input
                                                    type="file"
                                                    accept=".xlsx, .xls"
                                                    id="importLeadsFile"
                                                    onChange={handleImportLeads}
                                                    style={{ display: "none" }}
                                                />
                                                <label
                                                    htmlFor="importLeadsFile"
                                                    className="btn btn-light border mb-0"
                                                    data-bs-toggle="tooltip"
                                                    data-bs-placement="top"
                                                    title="Import Leads from Excel"
                                                >
                                                    <i className="mdi mdi-upload text-primary"></i>
                                                </label>

                                                {/* Add Lead Button */}
                                                <WithCreatePermission>
                                                    <button
                                                        type="button"
                                                        className="btn rounded-circle border d-flex align-items-center justify-content-center round-create-button"
                                                        onClick={() => handleShowModal()}
                                                        data-bs-toggle="tooltip"
                                                        data-bs-placement="top"
                                                        title="Add Lead"
                                                    >
                                                        <i className="mdi mdi-plus"></i>
                                                    </button>
                                                </WithCreatePermission>
                                            </div>
                                        </div>

                                        <table className="table align-middle table-nowrap table-check table-list">
                                            <thead className="table-light">
                                                <tr>
                                                    <th style={{ width: '20px' }} className="align-middle">
                                                        <div className="form-check font-size-16">
                                                            <input className="form-check-input" type="checkbox" id="checkAll" />
                                                            <label className="form-check-label" htmlFor="checkAll"></label>
                                                        </div>
                                                    </th>
                                                    <th className="align-middle">#</th>
                                                    <th className="align-middle"> Lead Name</th>
                                                    <th className="align-middle"> Organisation
                                                        <div className="dropdown d-inline-block">
                                                            <FaFilter
                                                                className="ms-2 cursor-pointer filter-color"
                                                                onClick={() => setFilterDropdown(filterDropdown === 'org' ? null : 'org')}
                                                            />
                                                            {filterDropdown === 'org' && (
                                                                <ul className="dropdown-menu show">
                                                                    <li><button className="dropdown-item" onClick={() => handleFilterChange('org', '')}>All</button></li>
                                                                    {organisations.map((type) => (
                                                                        <li key={type.id}>
                                                                            <button className="dropdown-item" onClick={() => handleFilterChange('org', type.id)}>
                                                                                {type.name}
                                                                            </button>
                                                                        </li>
                                                                    ))}
                                                                </ul>
                                                            )}
                                                        </div>
                                                    </th>
                                                    <th className="align-middle">Lead Source
                                                        <div className="dropdown d-inline-block">
                                                            <FaFilter
                                                                className="ms-2 cursor-pointer filter-color"
                                                                onClick={() => setFilterDropdown(filterDropdown === 'type' ? null : 'type')}
                                                            />
                                                            {filterDropdown === 'type' && (
                                                                <ul className="dropdown-menu show">
                                                                    <li>
                                                                        <button className="dropdown-item" onClick={() => handleFilterChange('type', '')}>
                                                                            All
                                                                        </button>
                                                                    </li>
                                                                    <li>
                                                                        <button className="dropdown-item" onClick={() => handleFilterChange('type', 'partner')}>
                                                                            Partner
                                                                        </button>
                                                                    </li>
                                                                    <li>
                                                                        <button className="dropdown-item" onClick={() => handleFilterChange('type', 'consultant')}>
                                                                            Consultant
                                                                        </button>
                                                                    </li>
                                                                    <li>
                                                                        <button className="dropdown-item" onClick={() => handleFilterChange('type', 'inside sale')}>
                                                                            Inside Sales
                                                                        </button>
                                                                    </li>
                                                                    <li>
                                                                        <button className="dropdown-item" onClick={() => handleFilterChange('type', 'sales generated')}>
                                                                            Sales Generated
                                                                        </button>
                                                                    </li>

                                                                </ul>
                                                            )}
                                                        </div>
                                                    </th>
                                                    {/* <th className="align-middle">Status</th> */}

                                                    <th className="align-middle">Action</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {leads.length > 0 ? (
                                                    leads.map((lead, index) => (
                                                        <tr key={lead.id}>
                                                            <td>
                                                                <div className="form-check font-size-16">
                                                                    <input
                                                                        className="form-check-input"
                                                                        type="checkbox"
                                                                        id={`leadCheck${index}`}
                                                                    />
                                                                    <label
                                                                        className="form-check-label"
                                                                        htmlFor={`leadCheck${index}`}
                                                                    ></label>
                                                                </div>
                                                            </td>
                                                            <td>{index + 1}</td>
                                                            <td>
                                                                <button
                                                                    onClick={() => handleShowLeadDetails(lead.id)} // Pass lead ID
                                                                    className="dropdown-item"
                                                                >
                                                                    {lead?.name}
                                                                </button>
                                                            </td>

                                                            <td>
                                                                {lead.organisation ? lead.organisation.name : " "}

                                                            </td>
                                                            <td>{lead.lead_source}</td>

                                                            {/* <td>{lead.status}</td> */}
                                                            <td>
                                                                <div className="dropdown">
                                                                    <i
                                                                        className="mdi mdi-dots-horizontal font-size-18"
                                                                        data-bs-toggle="dropdown"
                                                                        aria-expanded="false"
                                                                        style={{ cursor: 'pointer' }}
                                                                    ></i>
                                                                    <ul className="dropdown-menu dropdown-menu-end font-size-14">
                                                                        <li>
                                                                            {/* <Link to={`/lead/details/${lead.id}`} className="dropdown-item"> */}
                                                                            <button
                                                                                onClick={() => handleShowLeadDetails(lead.id)} // Pass lead ID
                                                                                className="dropdown-item"
                                                                            >
                                                                                View Details
                                                                            </button>
                                                                            {/* </Link> */}
                                                                        </li>
                                                                        <li>
                                                                            <button
                                                                                className="dropdown-item"
                                                                                onClick={() => handleConvertModal(lead)}
                                                                            >
                                                                                Convert
                                                                            </button>
                                                                        </li>
                                                                        <li><WithEditPermission>
                                                                            <button
                                                                                className="dropdown-item"
                                                                                onClick={() => handleShowModal(lead.id)}
                                                                            >
                                                                                Edit
                                                                            </button></WithEditPermission>
                                                                        </li>
                                                                        <li><WithDeletePermission>
                                                                            <button
                                                                                className="dropdown-item"
                                                                                onClick={() => deleteLead(lead.id)}
                                                                            >
                                                                                Delete
                                                                            </button></WithDeletePermission>
                                                                        </li>
                                                                    </ul>
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    ))
                                                ) : (
                                                    <tr>
                                                        <td colSpan="5" className="text-center">No leads found.</td>
                                                    </tr>
                                                )}
                                            </tbody>
                                        </table>
                                        <div className="d-flex justify-content-end pagination-sm">
                                            <ReactPaginate
                                                previousLabel={'<'}
                                                nextLabel={'>'}
                                                breakLabel={'...'}
                                                pageCount={pageCount}
                                                marginPagesDisplayed={2}
                                                pageRangeDisplayed={3}
                                                onPageChange={handlePageClick}
                                                containerClassName={'pagination pagination-rounded justify-content-end mb-2'}
                                                pageClassName={'page-item'}
                                                pageLinkClassName={'page-link'}
                                                previousClassName={'page-item previous'}
                                                previousLinkClassName={'page-link'}
                                                nextClassName={'page-item next'}
                                                nextLinkClassName={'page-link'}
                                                breakClassName={'page-item'}
                                                breakLinkClassName={'page-link'}
                                                activeClassName={'active'}
                                            />
                                        </div>
                                    </div>
                                </div>
                            ) : (
                                <div className="row">
                                    <div className='d-flex align-items-center justify-content-end '>
                                        <div>
                                            <ul className="nav nav-pills justify-content-end">
                                                <li className="nav-item">
                                                    <a className="nav-link disabled" href="#" tabIndex={-1} aria-disabled="true"></a>
                                                </li>
                                                <li className="nav-item" data-bs-placement="top" title="List">
                                                    <a
                                                        className={`nav-link ${viewType === 'list' ? 'bg-primary bg-soft' : ''}`}
                                                        href="#"
                                                        onClick={() => setViewType('list')}
                                                    >
                                                        <i className="mdi mdi-format-list-bulleted" />
                                                    </a>
                                                </li>
                                                <li className="nav-item" data-bs-placement="top" title="Grid">
                                                    <a
                                                        className={`nav-link ${viewType === 'grid' ? 'bg-primary bg-soft' : ''}`}
                                                        href="#"
                                                        onClick={() => setViewType('grid')}
                                                    >
                                                        <i className="mdi mdi-view-grid-outline" />
                                                    </a>
                                                </li>
                                            </ul>
                                        </div>&nbsp;&nbsp;
                                        <WithCreatePermission>
                                            <button
                                                type="button"
                                                className="btn rounded-circle border d-flex align-items-center justify-content-center"
                                                style={{
                                                    width: "30px",
                                                    height: "30px",
                                                    padding: "5px",
                                                    backgroundColor: "rgb(201 227 236)",
                                                    borderColor: "#ccc",
                                                    color: "#333",
                                                }}
                                                onClick={() => handleShowModal()}
                                                data-bs-toggle="tooltip"
                                                data-bs-placement="top"
                                                id="tool"
                                                title="Add Deal"
                                            >
                                                <i className="mdi mdi-plus" style={{ fontSize: "16px" }}></i>
                                            </button></WithCreatePermission>
                                    </div>
                                    {leads.length > 0 ? (
                                        leads.map((deal, index) => (
                                            <div key={deal.id} className="col-xl-4 col-sm-6">
                                                <Card className='ccard1'>
                                                    <Card.Body>
                                                        <div className="d-flex">
                                                            <div className="flex-shrink-0 me-4">
                                                                <div className="avatar-md">
                                                                    <span className="avatar-title rounded-circle bg-light text-success font-size-16">
                                                                        {deal.name ? deal.name[0].toUpperCase() : 'N'}
                                                                    </span>
                                                                </div>
                                                            </div>
                                                            <div className="flex-grow-1 overflow-hidden">
                                                                <h5 className="text-truncate font-size-15">
                                                                    <Link to={`/lead/details/${deal.id}`} className="dropdown-item text-dark">{deal.name}</Link>
                                                                </h5>
                                                                <p className="text-muted mb-4">{deal.organisation ? deal.organisation.name : "No Organisation"}</p>
                                                                <div className="avatar-group">
                                                                    <div className="avatar-group-item">
                                                                        <p className="text-muted mb-4">{deal.lead_source}</p>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </Card.Body>
                                                    <div className="px-4 py-3 border-top">
                                                        <ul className="list-inline mb-0">

                                                            <li className="list-inline-item me-3">
                                                                <i className="bx bx-calendar me-1" />
                                                                {new Date(deal.created_at).toISOString().split("T")[0]}
                                                            </li>


                                                        </ul>
                                                    </div>
                                                </Card>
                                            </div>

                                        ))
                                    ) : (
                                        <p>No deals found.</p>
                                    )}
                                    <div className="d-flex justify-content-end pagination-sm">
                                        <ReactPaginate
                                            previousLabel={'<'}
                                            nextLabel={'>'}
                                            breakLabel={'...'}
                                            pageCount={pageCount}
                                            marginPagesDisplayed={2}
                                            pageRangeDisplayed={3}
                                            onPageChange={handlePageClick}
                                            containerClassName={'pagination pagination-rounded justify-content-end mb-2'}
                                            pageClassName={'page-item'}
                                            pageLinkClassName={'page-link'}
                                            previousClassName={'page-item previous'}
                                            previousLinkClassName={'page-link'}
                                            nextClassName={'page-item next'}
                                            nextLinkClassName={'page-link'}
                                            breakClassName={'page-item'}
                                            breakLinkClassName={'page-link'}
                                            activeClassName={'active'}
                                        />
                                    </div>
                                </div>

                            )}
                            {/* {showConvertModal && (
                                        <Modal show={showConvertModal} onHide={() => setShowConvertModal(false)}>
                                            <Modal.Header closeButton>
                                                <Modal.Title>Convert Lead</Modal.Title>
                                            </Modal.Header>
                                            <Modal.Body>
                                                <form>
                                                    <div className="mb-3">
                                                        <label className="form-label">Deal Name</label>
                                                        <input type="text" className="form-control" value={dealData.deal_name} 
                                                         onChange={(e) => setDealData({ ...dealData, name: e.target.value })} />
                                                    </div>
                                                    <div className="mb-3">
                                                        <label className="form-label">Closed Date</label>
                                                        <input type="date" className="form-control" value={dealData.closed_date}
                                                            onChange={(e) => setDealData({ ...dealData, closed_date: e.target.value })} />
                                                    </div>
                                                    <div className="mb-3">
                                                        <label className="form-label">Stage</label>
                                                        <select className="form-control" value={dealData.stage}
                                                            onChange={(e) => setDealData({ ...dealData, stage: e.target.value })}>
                                                            <option value="">Select </option>
                                                            <option value="suspect">Suspect </option>
                                                            <option value="prospect">Prospect </option>
                                                            <option value="approach">Approach </option>
                                                            <option value="negotiation">Negotiation </option>
                                                            <option value="closed won">Closed Won </option>
                                                            <option value="closed lost">Closed Lost </option>
                                                            <option value="closed dead">Closed Dead </option>
                                                            <option value="order">Order </option>
                                                        </select>
                                                    </div>
                                                    <div className="mb-3">
                                                        <label className="form-label">Amount</label>
                                                        <input type="number" className="form-control" value={dealData.amount}
                                                            onChange={(e) => setDealData({ ...dealData, amount: e.target.value })} />
                                                    </div>
                                                </form>
                                            </Modal.Body>
                                            <Modal.Footer>
                                                <button className="btn btn-secondary" onClick={() => setShowConvertModal(false)}>Cancel</button>
                                                <button className="btn btn-primary" onClick={handleConvertLeadToDeal}>Save</button>
                                            </Modal.Footer>
                                        </Modal>

                                    )} */}
                            {showConvertModal && (
                                <Offcanvas
                                    show={showConvertModal}
                                    onHide={() => setShowConvertModal(false)}
                                    placement="end" // This makes it slide in from the right
                                    style={{ width: '450px' }}
                                    backdrop="static"
                                >
                                    <Offcanvas.Header closeButton>
                                        <Offcanvas.Title>Convert Lead</Offcanvas.Title>
                                    </Offcanvas.Header>
                                    <hr style={{ margin: 0 }} /><br />


                                    <Offcanvas.Body>
                                        <form>
                                            <div className="mb-3">
                                                <label className="form-label" style={{ fontSize: '13px' }}>Deal Name</label>
                                                <input
                                                    style={{ fontSize: '13px' }}
                                                    type="text"
                                                    className="form-control"
                                                    value={dealData.deal_name}
                                                    onChange={(e) => setDealData({ ...dealData, deal_name: e.target.value })}
                                                />
                                            </div>
                                            <div className="mb-3">
                                                <label className="form-label" style={{ fontSize: '13px' }}>Closed Date</label>
                                                <input
                                                    style={{ fontSize: '13px' }}
                                                    type="date"
                                                    className="form-control"
                                                    value={dealData.closed_date}
                                                    onChange={(e) => setDealData({ ...dealData, closed_date: e.target.value })}
                                                />
                                            </div>
                                            <div className="mb-3">
                                                <label className="form-label" style={{ fontSize: '13px' }}>Stage</label>
                                                <select
                                                    className="form-control"
                                                    style={{ fontSize: '13px' }}
                                                    value={dealData.stage}
                                                    onChange={(e) => setDealData({ ...dealData, stage: e.target.value })}
                                                >
                                                    <option value="">Select</option>
                                                    <option value="suspect">Suspect</option>
                                                    <option value="prospect">Prospect</option>
                                                    <option value="approach">Approach</option>
                                                    <option value="negotiation">Negotiation</option>
                                                    <option value="closed won">Closed Won</option>
                                                    <option value="closed lost">Closed Lost</option>
                                                    <option value="closed dead">Closed Dead</option>
                                                    <option value="order">Order</option>
                                                </select>
                                            </div>
                                            <div className="mb-3">
                                                <label className="form-label" style={{ fontSize: '13px' }}>Amount</label>
                                                <input
                                                    type="number"
                                                    className="form-control"
                                                    value={dealData.amount}
                                                    onChange={(e) => setDealData({ ...dealData, amount: e.target.value })}
                                                />
                                            </div>
                                        </form><br />
                                        <div className="d-flex justify-content-end mt-3">
                                            <button className="btn btn-secondary me-2" onClick={() => setShowConvertModal(false)}>
                                                Cancel
                                            </button>
                                            <button className="btn btn-primary" onClick={handleConvertLeadToDeal}>
                                                Save
                                            </button>
                                        </div>
                                    </Offcanvas.Body>
                                </Offcanvas>
                            )}


                        </div>
                    </div>
                </div>
            </div>
            <LeadModal
                showModal={showModal}
                handleClose={handleCloseModal}
                leadId={selectedLeadId}
                leadData={selectedLeadData}
                addLead={addLead}
                editLead={editLead}
                leads={leads}
                fetchContacts={fetchContacts}
                fetchOrganisation={fetchOrganisation}
                errors={errors}
                setErrors={setErrors}
                contacts={contacts}
                organisations={organisations}
                setShowModal={setShowModal}
                setOrganisation={setOrganisation}
                setContacts={setContacts}

            // leadIdError={leadIdError}

            />
            <LeadDetails
                show={showLeadOffcanvas}
                onHide={handleCloseLeadDetails}
                leadId={selectedLeadId}
            // onOrganisationUpdate={fetchOrganisation} // Pass refresh function if needed
            />
        </div>
    );
};

export default LeadList;




